import React, { useState } from 'react';
import { aeroxchangeSource, QUOTE_LINE_PROCESSED_STATUSES, QUOTE_LINE_SELECTED_STATES } from '../../pages/WMS_SMS/data';

export default function QuoteLineRow({
    quoteLineData,
    selectedQuoteLines,
    updateQuoteLineComments,
    email,
    setCommentData,
    updateSelectedQuoteLines,
    selectedInventory,
}) {
    const [showPopup, setShowPopup] = useState(false);
    const defaultPopupPosition = { left: '0px', top: '0px' };
    const [popupPositionStyle, setPopupPositionStyle] = useState(defaultPopupPosition);
    const { REQUESTED, PROCESSED, RESPONDED } = QUOTE_LINE_PROCESSED_STATUSES;

    const maxSelectedInventoryForAeroXchange = 2;
    const isAeroxchange = quoteLineData.source === aeroxchangeSource;

    let currentStatus = '';
    if (quoteLineData?.selectedState === QUOTE_LINE_SELECTED_STATES.LOCKED) {
        currentStatus = ' bg-gray-300 ';
        if (quoteLineData?.selectedState === QUOTE_LINE_SELECTED_STATES.LOCKED && email !== quoteLineData?.email)
            currentStatus = ' bg-gray-300 pointer-events-none ';
    }

    if (quoteLineData?.selectedState !== QUOTE_LINE_SELECTED_STATES.LOCKED) {
        if (quoteLineData?.currentStep === REQUESTED) currentStatus = ' bg-blue-200 pointer-events-none ';
        if (quoteLineData?.currentStep === PROCESSED) currentStatus = ' bg-blue-200 pointer-events-none ';
        if (quoteLineData?.currentStep === RESPONDED) currentStatus = ' bg-blue-200 pointer-events-none ';
    }

    return (
        <tr className={'text-center border-b last:!border-none ' + currentStatus}>
            <td className='px-4 py-3 !font-normal max-w-[250px]'>
                <h1 className={quoteLineData?.highlighted && 'bg-yellow-300 bg-opacity-40 py-1'}>
                    {quoteLineData.customer}
                </h1>
            </td>
            <td>{quoteLineData.type}</td>
            <td>{quoteLineData.quoteLineNumber}</td>
            <td>
                <h1 className={quoteLineData.hasDuplicate ? 'bg-orange-500 bg-opacity-25 py-1' : ''}>
                    {quoteLineData.quoteNumber}
                </h1>
            </td>
            <td>{quoteLineData.createdDate}</td>
            <td>{quoteLineData.source}</td>
            <td>{quoteLineData.quoteStatus}</td>
            <td>{quoteLineData.quantity}</td>
            <td>{quoteLineData.conditionCode}</td>
            <td>{quoteLineData.priority}</td>
            <td>
                {showPopup &&
                ((quoteLineData?.externalComments && quoteLineData?.externalComments !== '') ||
                    (quoteLineData?.updatedComments && quoteLineData?.updatedComments !== '')) ? (
                    <article className='flex absolute z-50 w-[300px]' style={popupPositionStyle}>
                        <div className='min-w-[140px] bg-gray-800 text-white rounded-md px-2 py-1 whitespace-pre-wrap break-words'>
                            {quoteLineData?.updatedComments || quoteLineData?.externalComments}
                        </div>
                    </article>
                ) : null}
                <textarea
                    onChange={(e) => {
                        updateQuoteLineComments(quoteLineData?.quoteLineId, e.target.value);
                    }}
                    className='max-w-[110px] px-1 py-2 border rounded-md resize-none'
                    type='text'
                    value={quoteLineData?.updatedComments ?? quoteLineData?.externalComments}
                    id={quoteLineData?.quoteLineId}
                    onMouseOver={() => {
                        const rect = document.getElementById(quoteLineData?.quoteLineId).getBoundingClientRect();
                        const x = rect.left + window.scrollX - rect.width / 2;
                        const y = rect.bottom + window.scrollY + 4;

                        setPopupPositionStyle({ left: x, top: y });
                        setShowPopup(true);
                    }}
                    onMouseLeave={() => {
                        setShowPopup(false);
                    }}
                    onDoubleClick={() =>
                        setCommentData({
                            quoteLineId: quoteLineData?.quoteLineId,
                            comments: quoteLineData?.updatedComments ?? quoteLineData?.externalComments,
                            open: true,
                        })
                    }
                    rows={1}
                />
            </td>
            <td>
                <div className='flex justify-center items-center w-full h-full'>
                    <input
                        type='checkbox'
                        className='scale-150'
                        checked={
                            quoteLineData.selectedState === QUOTE_LINE_SELECTED_STATES.LOCKED &&
                            selectedQuoteLines.some((line) => line === quoteLineData.quoteLineNumber)
                        }
                        onChange={(e) => {
                            updateSelectedQuoteLines(
                                e,
                                quoteLineData.quoteLineNumber,
                                QUOTE_LINE_SELECTED_STATES.LOCKED,
                                quoteLineData.autoId
                            );
                        }}
                    />
                </div>
            </td>
            {/* <td>
                <div className='flex justify-center items-center w-full h-full'>
                    <input
                        type='checkbox'
                        className='scale-150'
                        checked={
                            quoteLineData.currentStep
                                ? quoteLineData.selectedState === QUOTE_LINE_SELECTED_STATES.IGNORE
                                : quoteLineData?.selectedState === QUOTE_LINE_SELECTED_STATES.IGNORE &&
                                  selectedQuoteLines.some((line) => line === quoteLineData.quoteLineNumber)
                        }
                        onChange={(e) =>
                            updateSelectedQuoteLines(
                                e,
                                quoteLineData.quoteLineNumber,
                                QUOTE_LINE_SELECTED_STATES.IGNORE,
                                quoteLineData.autoId
                            )
                        }
                    />
                </div>
            </td> */}
            <td>
                <div className='flex justify-center items-center w-full h-full'>
                    <input
                        type='checkbox'
                        className='scale-150'
                        checked={
                            quoteLineData.currentStep
                                ? quoteLineData.selectedState === QUOTE_LINE_SELECTED_STATES.NO_QUOTE
                                : quoteLineData?.selectedState === QUOTE_LINE_SELECTED_STATES.NO_QUOTE &&
                                  selectedQuoteLines.some((line) => line === quoteLineData.quoteLineNumber)
                        }
                        onChange={(e) =>
                            updateSelectedQuoteLines(
                                e,
                                quoteLineData.quoteLineNumber,
                                QUOTE_LINE_SELECTED_STATES.NO_QUOTE,
                                quoteLineData.autoId
                            )
                        }
                    />
                </div>
            </td>
            <td>
                <div className='flex justify-center items-center w-full h-full'>
                    <input
                        type='checkbox'
                        className='scale-150'
                        checked={
                            quoteLineData.currentStep
                                ? quoteLineData.selectedState === QUOTE_LINE_SELECTED_STATES.SELECT
                                : quoteLineData?.selectedState === QUOTE_LINE_SELECTED_STATES.SELECT &&
                                  selectedQuoteLines.some((line) => line === quoteLineData.quoteLineNumber)
                        }
                        onChange={(e) =>
                            updateSelectedQuoteLines(
                                e,
                                quoteLineData.quoteLineNumber,
                                QUOTE_LINE_SELECTED_STATES.SELECT,
                                quoteLineData.autoId
                            )
                        }
                    />
                </div>
            </td>
        </tr>
    );
}
